import { render, staticRenderFns } from "./ackAppraise.vue?vue&type=template&id=81683ae2&scoped=true"
import script from "./ackAppraise.vue?vue&type=script&lang=js"
export * from "./ackAppraise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81683ae2",
  null
  
)

export default component.exports